import fields from './fields'
import formUtils from 'shared/src/formUtils'

const getComponent = (component) => {
  let Component = typeof(component) === 'string' ?
      fields[component] :
      component

  if(!Component) Component = fields.text

  return Component
}

const utils = {
  flattenSchema: formUtils.flattenSchema,
  getComponent,
  getInitialValues: formUtils.getInitialValues,
}

export default utils